export interface TimelineFeedItem {
  date: string;
  time: string;
  slug: string;
  title: string;
  summary: string;
  categoryName: string;
  tag: string;
}

export const timelineFeed: TimelineFeedItem[] = [
  {
    date: '09-08',
    time: '09:00',
    slug: 'dingji-liuliang-luyin-fengbo',
    title: '粉丝长文被删，转发停在 4 万',
    summary: '一篇把两版音频逐句对齐的长文在传播四小时后消失，原作者未说明原因。',
    categoryName: '娱乐圈',
    tag: '存疑',
  },
  {
    date: '09-08',
    time: '11:20',
    slug: 'zhibo-daihuo-shuju-yiyun',
    title: '带货机构仍未提供原始流水',
    summary: '距离前员工爆料已过去两天，机构仅重申「截图非后台数据」，未公布完整后台记录。',
    categoryName: '网红圈',
    tag: '待回应',
  },
  {
    date: '09-07',
    time: '16:05',
    slug: 'dingji-liuliang-luyin-fengbo',
    title: '完整音频出现，语境完全改变',
    summary: '第三方补发 3 分 42 秒版本，此前被解读为关键的半句话，在完整对话中指向另一层意思。',
    categoryName: '娱乐圈',
    tag: '反转',
  },
  {
    date: '09-06',
    time: '14:20',
    slug: 'zhibo-daihuo-shuju-yiyun',
    title: '前员工晒出两张后台截图',
    summary: '截图显示深夜时段出现集中退款，爆料人称与之对应的正是战报里的高光时段。',
    categoryName: '网红圈',
    tag: '发酵',
  },
  {
    date: '09-06',
    time: '11:30',
    slug: 'dingji-liuliang-luyin-fengbo',
    title: '工作室首次回应，措辞强硬',
    summary: '声明称音频经剪辑拼接，但未逐段说明剪辑点位置，也未提供对照版本。',
    categoryName: '娱乐圈',
    tag: '回应',
  },
  {
    date: '09-05',
    time: '11:00',
    slug: 'dianjing-xuanshou-daidap',
    title: '联盟公布核查结果：不存在代打',
    summary: '以设备输入日志为主要依据，认定整场训练赛使用同一套外设，事件反转收尾。',
    categoryName: '电竞圈',
    tag: '反转',
  },
  {
    date: '09-05',
    time: '18:40',
    slug: 'qiye-gaoguan-qunliao-waixie',
    title: '技术博主指出截图三处像素异常',
    summary: '头像锯齿、圆角半径与时间戳位数不一致，让截图来源比内容更受关注。',
    categoryName: '商界',
    tag: '存疑',
  },
  {
    date: '09-03',
    time: '10:20',
    slug: 'lianxishi-jieyue-fengbo',
    title: '解约双方就「通知时间」各执一词',
    summary: '两份聊天记录把通知与拒绝的顺序对调，核心争议从合约条款转向记录真伪。',
    categoryName: '娱乐圈',
    tag: '发酵',
  },
  {
    date: '09-01',
    time: '09:30',
    slug: 'tiyu-mingxing-xingcheng',
    title: '行程表事件暂无正式回应',
    summary: '表格中三天与官方赛程直接冲突，团队未就该表格作出任何说明。',
    categoryName: '体育圈',
    tag: '待回应',
  },
  {
    date: '08-30',
    time: '15:00',
    slug: 'wangkong-lianai-shijianxian',
    title: '恋爱时间线事件归档',
    summary: '可验证节点仅剩公开取关顺序，其余推测内容已被剔除，双方均未回应。',
    categoryName: '网红圈',
    tag: '归档',
  },
  {
    date: '08-29',
    time: '10:00',
    slug: 'shangye-jingzheng-ppt',
    title: '爆料 PPT 的传播路径被还原',
    summary: '首发三个账号注册时间接近，文件在十分钟内同步出现在多个投资人群。',
    categoryName: '商界',
    tag: '存疑',
  },
  {
    date: '08-27',
    time: '09:00',
    slug: 'yiren-xiaohao-yiyun',
    title: '小号疑云最关键的证据始终缺失',
    summary: '四条推理里，唯一客观的 IP 归属地只能定位到省，无法支撑关联结论。',
    categoryName: '娱乐圈',
    tag: '存疑',
  },
  {
    date: '08-24',
    time: '10:00',
    slug: 'hangye-shuijun-taolu',
    title: '三段式传播套路整理完成',
    summary: '输出「首发号—搬运号—解读号」的识别清单，供读者自查信息来源。',
    categoryName: '行业观察',
    tag: '归档',
  },
];